const LS_KEY_NAME = 'customer_import_upload_id'

export const setCustomerImportIdtoLs = (id) => localStorage.setItem(LS_KEY_NAME, id)
export const getCustomerImportIdFromLs = () => localStorage.getItem(LS_KEY_NAME)
export const removeCustomerImportIdFromLs = () => localStorage.removeItem(LS_KEY_NAME)
